import { Component, Input, ViewEncapsulation, OnInit, Output, EventEmitter } from '@angular/core';
import { NavItem } from './menu-item/nav-item';

@Component({
// tslint:disable-next-line: component-selector
	selector: 'tr2-menu',
	templateUrl: './menu.component.html',
	styleUrls: ['./menu.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class Menu implements OnInit {
	constructor() {
	}

	@Input() items: NavItem[] = [];
	@Output() establecido = new EventEmitter();

	ngOnInit() {
	}

	click(item) {
		this.establecido.emit(item);
	}
}
